import { tv } from "@utils/tw"

export const rowLinkStyles = tv({
  slots: {
    group: "flex flex-col group/rowlinks",
    row: "flex border-t border-white/20 items-center py-4 gap-5 text-white transition-colors group-has-[a:hover]/rowlinks:text-opacity-75 hover:!text-opacity-100",
  },
})

export const inputStyles = tv({
  base: [
    "w-full rounded-sm px-4 py-3 outline-none type-text-input appearance-none",
    "bg-transparent border border-white/20 text-white transition-colors",
    "focus:border-white/80",
    "placeholder:text-white/20",
  ],
})

export const adminMessage = tv({
  base: "border border-current text-[red] p-3 rounded-sm px-4 py-3",
})
